// extracted by mini-css-extract-plugin
export default {"particle-box":"ParticleBackground_particle-box__xtjo4"};